import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { RadioButton } from 'primereact/radiobutton';

import { Button } from '../../../helpers';
import { raiseToast } from '../../../services/redux/reducers/toast/toast';


const ConfirmDialog = (props) => {
    const { requestVendorPayment } = props

    const [serviceTDSDeclaration, setServiceTDSDeclaration] = useState('')

    const dispatch = useDispatch()

    const handleServiceTDSDeclaration = (e) => {
        setServiceTDSDeclaration(e.target.value)
    }

    const handleConfirmation = () => {
        if(!serviceTDSDeclaration){
            return dispatch(raiseToast({ severity: 'warn', detail: "Please confirm does the PIs to be punched has both services and goods or not" }))
        }

        requestVendorPayment(true, serviceTDSDeclaration)
    }
    
    return (
        <div className="flex flex-column">
            <div className="mt-2 flex flex-row">
                <p className="mt-1">This PO has both services and materials. If these will be punched in same PI - the services TDS will get applicable for materials as well - please confirm if they'll be punched on same PI or separate.</p>
            </div>
            <div className="mt-1 flex flex-row">
                <div className="my-1 flex flex-row ml-3">
                    <RadioButton inputId="not-required" name="not-required" value="Same" onChange={(e) => handleServiceTDSDeclaration(e)} checked={serviceTDSDeclaration === 'Same'} />
                    <label htmlFor="not-required" className="text-sm">Same</label>
                </div>
                <div className="my-1 flex flex-row ml-3">
                    <RadioButton inputId="not-required" name="not-required" value="Seperate" onChange={(e) => handleServiceTDSDeclaration(e)} checked={serviceTDSDeclaration === 'Seperate'} />
                    <label htmlFor="not-required" className="text-sm">Seperate</label>
                </div>
            </div>
            <div className="mt-1 flex flex-row">
                {
                    serviceTDSDeclaration === "Same" && <p className='p-0' style={{fontWeight: "bold"}} > Service TDS will be applicable for all materials in the PO. Are you sure you want to continue?</p>
                }
                {
                    serviceTDSDeclaration === "Seperate" && <p className='p-0' style={{fontWeight: "bold"}} >Services and materials are to be punched seperately. Are you sure you want to continue?</p>
                }
            </div>
            <div className="mt-2 flex flex-row justify-content-end">
                <Button label="Confirm" onClick={handleConfirmation} outlined />
            </div>
        </div>
    )
}

export default ConfirmDialog